import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import { KTextInput } from "@kyburz/kdesign-system";

interface Props {
  text: string;
  onChange: Function | any;
}

const Editable = ({ text, onChange }: Props) => {
  const [isEditing, setEditing] = useState(false);
  const [value, setValue] = useState(text);

  return (
    <>
      {isEditing ? (
        <div
          onBlur={() => {
            onChange(value);
            setEditing(false);
          }}
        >
          <KTextInput
            onChange={(e) => setValue(e.target.value)}
            value={value}
            size="small"
            style={{ marginTop: "-5px" }}
            width="100%"
          />
        </div>
      ) : (
        <div onClick={() => setEditing(true)}>
          {text.length > 0 ? (
            <Typography variant="body2">{text}</Typography>
          ) : (
            <Typography variant="body2" color="textSecondary">
              Click to edit
            </Typography>
          )}
        </div>
      )}
    </>
  );
};

export default Editable;
